import Vue from 'vue'
import VueRouter from 'vue-router';
import Index from './components/index/index';
import Aboutus from './components/index/aboutus';
import Product from './components/index/product';
import Customer from './components/index/customer';
import ProductDetail from './components/index/productDetail';

Vue.use(VueRouter);

const routes = [
  {path: '', redirect: '/index'},
  {path: '/index', component: Index,meta:{name:1}},
  {path: '/aboutus', component: Aboutus,meta:{name:3}},
  {path: '/product', component: Product,meta:{name:2}},
  {path: '/customer', component: Customer,meta:{name:4}},
  {path: '/productDetail/:id', component: ProductDetail},
];

export default new VueRouter({routes})
